/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MyContext } from '../../Context/MyProvider';
import CartIocn from "../../assets/Icon/cart.svg";
import restaurant from "../../assets/Icon/restaurant.svg";
import { useTranslation } from 'react-i18next';
import emptyOrder from "../../assets/Image/emptyOrder.png";
import Home from "../../assets/Icon/home.svg";
import testtube from "../../assets/Icon/testtube.svg";
import clock_circle from "../../assets/Icon/clock-circle.svg";
import package_box from "../../assets/Icon/package-box.svg";
import invoice from "../../assets/Icon/invoice.svg";
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import { applyImageFallback, buildImageUrl } from "../../utils/image";
const PackagesDetails = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl, setIsLoginShow } = useContext(MyContext);
    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const [loading, setLoading] = useState(true);
    const [popular, setPopular] = useState([]);
    const [affordable, setAffordable] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const [packageData, setPackageData] = useState();
    const [cartAddIndex, setCartAddIndex] = useState();
    const [loadingId, setLoadingId] = useState(null);
    const [apiloading, setApiLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totallength, setTotalLength] = useState(0);

    const hasReachedBottom = useRef(false);
    const NoMoreDataRef = useRef(true);
    const selectBtnRef = useRef(0);
    const navigate = useNavigate();

    const Data = sessionStorage.getItem("Docprofile");
    if (Data) {
        var { Categoryid, title, Labid, path } = JSON.parse(Data);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        handleFetchPopularData(1);
    }, []);

    const handleFetchPopularData = (page) => {
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/lab_indi_pack_list`, { id: Userid, category_id: Categoryid, lab_id: Labid, page })
                .then((res) => {
                    // console.log("lab_indi_pack_list", res);
                    const { ResponseCode, individual, cart_check } = res.data;
                    if (ResponseCode === 200) {
                        if (individual.length === 0 || totallength > individual.length) NoMoreDataRef.current = false;
                        if (page === 1) {
                            setPopular(individual);
                            setTotalLength(individual.length);
                        } else {
                            setPopular(prev => page === 1 ? individual : [...prev, ...individual]);
                        }

                        if (individual.length === 0) {
                            setPage(page - 1);
                        }
                        setCartAddIndex(cart_check);
                        setLoadingId("");

                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const handleFetchAffordableData = (page) => {
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/lab_pack_list`, { id: Userid, category_id: Categoryid, lab_id: Labid, page })
                .then((res) => {
                    // console.log("lab_pack_list", res);
                    const { ResponseCode, cart_check } = res.data;
                    const Data = res.data.package;
                    if (ResponseCode === 200) {
                        if (Data.length === 0 || totallength > Data.length) NoMoreDataRef.current = false;
                        if (page === 1) {
                            setAffordable(Data);
                            setTotalLength(Data.length);
                        } else {
                            setAffordable(page === 1 ? Data : [...affordable, ...Data]);
                        }
                        setCartAddIndex(cart_check);
                    }
                    setLoading(false);
                    setLoadingId("");
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            const clientHeight = window.innerHeight;

            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

            if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
                hasReachedBottom.current = true;
                setPage(prevPage => prevPage + 1);
            } else if (!isAtBottom && hasReachedBottom.current) {
                hasReachedBottom.current = false;
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (page === 1) return;

        if (selectBtnRef.current === 0) {
            handleFetchPopularData(page);
        } else {
            handleFetchAffordableData(page)
        }
    }, [page])

    const HandleDetails = (id) => {
        setApiLoading(true);
        setIsShow(true);

        axios.post(`${ApiBaseUrl}/customer/lab_package_details`, { package_id: id })
            .then((res) => {
                // console.log(res);
                if (res.data.ResponseCode === 200) {
                    setPackageData(res.data.package_data);
                    setApiLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const HandleBook = (id, e) => {
        e.stopPropagation();
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            setLoadingId(id);
            axios.post(`${ApiBaseUrl}/customer/add_cart`, { id: Userid, lab_id: Labid, package_id: id })
                .then((res) => {
                    // console.log("add_cart", res);
                    if (res.data.ResponseCode === 200) {
                        if (selectBtnRef.current === 0) {
                            handleFetchPopularData(page || 1);
                        } else {
                            handleFetchAffordableData(page || 1);
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        } else {
            setIsLoginShow(true);
        }
    };

    useEffect(() => {
        document.body.style.overflow = "auto";
    }, [loading]);

    const HandleSelectBtn = (index) => {
        selectBtnRef.current = index;
        NoMoreDataRef.current = true;
        setTotalLength(0);
        setPage(0);

        if (index === 0) {
            handleFetchPopularData(1);
        } else {
            handleFetchAffordableData(1)
        }
    }

    return (
        <div className='width-container pb-[50px] lab-details'>

            {false ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="">
                    <div className="flex items-center justify-between top-section">
                        <Link to="/" className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
                            <IoIosArrowBack className=' group-hover:text-white' />
                            <h1 className='font-[500] group-hover:text-white'>{t("Go Home")}</h1>
                        </Link>
                        <div className="flex items-center gap-[10px]">
                            <Link to={path} className='font-[500] text-gray-700'>{title}</Link>
                            <IoIosArrowForward />
                            <h1 className='font-[500] text-gray-400 pagename'>{t("Packages")}</h1>
                        </div>
                    </div>

                    <div className="flex justify-center mt-[25px]">
                        <div className="bg-[#F6F7F8] Select-btn p-[5px] rounded-[50px] flex gap-[20px]">
                            <button onClick={() => HandleSelectBtn(0)} className={`${selectBtnRef.current === 0 && "active"}`}>{t("Popular Tests")}</button>
                            <button onClick={() => HandleSelectBtn(1)} className={`${selectBtnRef.current === 1 && "active"}`}>{t("Affordable Packages")}</button>
                        </div>
                    </div>
                    <div className="mt-[15px]">
                        <h1 className='d-title'>{t("Recommended Packages")}</h1>
                        <div className="mt-[30px] flex flex-wrap items-center gap-[20px]">
                            {selectBtnRef.current === 0
                                ? (popular.length >= 1
                                    ? popular?.map((item, index) => {
                                        const isLoading = loadingId === item.id;
                                        return <div onClick={() => HandleDetails(item.id)} key={index} className="card-box">
                                            <img className='photo object-contain' src={buildImageUrl(ImgBaseUrl, item.logo, "package")} onError={(e) => applyImageFallback(e, ImgBaseUrl, "package")} alt="" />
                                            <div className="p-[10px]">
                                                <h1 className='text-[18px]'>{item.title}</h1>
                                                <h1 className='text-[16px] font-[500] underline'>{t("Includes")} {item.package_name} {t("tests")}</h1>
                                                <div className="flex items-center justify-between mb-[8px]">
                                                    <h1 className='text-[18px] font-[500]'>{currency} {item.package_price}</h1>
                                                    <div className={`py-[5px] px-[25px] ${item.exist === 0 ? "bg-[#0d9488]" : "bg-red-500"} rounded-[10px]`}>
                                                        {isLoading ? <span className="loader"></span> : <button onClick={(e) => HandleBook(item.id, e)} className="text-white font-[500]">{item.exist === 0 ? t("Book") : t("Remove")}</button>}
                                                    </div>
                                                </div>
                                                <div className=" text-gray-500 flex items-center gap-[20px] border-t-[1px] border-[#8080803b] pt-[8px]">
                                                    <div className="flex items-center gap-[5px]">
                                                        <img src={restaurant} alt="" />
                                                        <h1 className='text-[15px]'>{item.fasting_require}</h1>
                                                    </div>
                                                    <div className="flex items-center gap-[5px]">
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M3 6C3 3.79086 4.79086 2 7 2H17C19.2091 2 21 3.79086 21 6V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V6Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                                            <path d="M8 17H12" stroke="#28303F" stroke-width="1.5" stroke-linecap="round" />
                                                            <path d="M8 12H16" stroke="#28303F" stroke-width="1.5" stroke-linecap="round" />
                                                            <path d="M8 7H16" stroke="#28303F" stroke-width="1.5" stroke-linecap="round" />
                                                        </svg>
                                                        <h1 className='text-[15px]'>{t("Reports in")} {item.test_report_time} {t("Hours")}</h1>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                    : <div className='w-[100%] h-[300px] flex items-center'>
                                        <img src={emptyOrder} className='w-[200px] mx-auto' alt="" />
                                    </div>)
                                : (affordable.length >= 1
                                    ? affordable?.map((item, index) => {
                                        const isLoading = loadingId === item.id;
                                        return <div onClick={() => HandleDetails(item.id)} key={index} className="card-box">
                                            <img className='photo object-contain' src={buildImageUrl(ImgBaseUrl, item.logo, "package")} onError={(e) => applyImageFallback(e, ImgBaseUrl, "package")} alt="" />
                                            <div className="p-[10px]">
                                                <h1 className='text-[18px]'>{item.title}</h1>
                                                <h1 className='text-[16px] font-[500] underline'>{t("Includes")} {item.package_name} {t("tests")}</h1>
                                                <div className="flex items-center justify-between mb-[8px]">
                                                    <h1 className='text-[18px] font-[500]'>{currency} {item.package_price}</h1>
                                                    <div className={`py-[5px] px-[25px] ${item.exist === 0 ? "bg-[#0d9488]" : "bg-red-500"} rounded-[10px]`}>
                                                        {isLoading ? <span className="loader"></span> : <button onClick={(e) => HandleBook(item.id, e)} className="text-white font-[500]">{item.exist === 0 ? t("Book") : t("Remove")}</button>}
                                                    </div>
                                                </div>
                                                <div className=" text-gray-500 flex items-center gap-[20px] border-t-[1px] border-[#8080803b] pt-[8px]">
                                                    <div className="flex items-center gap-[5px]">
                                                        <img src={restaurant} alt="" />
                                                        <h1>{item.fasting_require}</h1>
                                                    </div>
                                                    <div className="flex items-center gap-[5px]">
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M3 6C3 3.79086 4.79086 2 7 2H17C19.2091 2 21 3.79086 21 6V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V6Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                                            <path d="M8 17H12" stroke="#28303F" stroke-width="1.5" stroke-linecap="round" />
                                                            <path d="M8 12H16" stroke="#28303F" stroke-width="1.5" stroke-linecap="round" />
                                                            <path d="M8 7H16" stroke="#28303F" stroke-width="1.5" stroke-linecap="round" />
                                                        </svg>
                                                        <h1>{t("Reports in")} {item.test_report_time} {t("Hours")}</h1>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                    : <div className='w-[100%] h-[300px] flex items-center'>
                                        <img src={emptyOrder} className='w-[200px] mx-auto' alt="" />
                                    </div>)}
                        </div>
                    </div>
                </div>}

            {isShow && <div onClick={() => setIsShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[700px] max-_430_:max-h-[500px] scroll-container">
                    {false ? <Loading CustomeStyle="w-full h-[500px] flex items-center justify-center" />
                        : <div className="">
                            <div className="flex items-center gap-[20px]">
                                <img src={buildImageUrl(ImgBaseUrl, packageData?.logo, "package")} onError={(e) => applyImageFallback(e, ImgBaseUrl, "package")} className='border-[2px] border-[#8080803b] h-[100px] w-[100px] object-contain rounded-[10px]' alt="" />
                                <div className="">
                                    <h1 className='font-[500] text-[18px]'>{packageData?.title}</h1>
                                    <p className='text-gray-600 leading-[18px] mt-[5px]'>{packageData?.subtitle}</p>
                                </div>
                            </div>
                            <div className="mt-[15px]">
                                <div className="flex items-center gap-[10px]">
                                    <div className="flex items-center gap-[10px]">
                                        <img src={Home} className='w-[20px]' alt="" />
                                        <h1 className='font-[500]'>{t("Home Collect Extra Price")}</h1>
                                    </div>
                                    <h1 className='bg-orange-100 border-[2px] border-[#8080803b] px-[10px] py-[1px] font-[500] rounded-[5px]'>{currency} {packageData?.home_extra_price}</h1>
                                </div>
                                <div className="flex items-center gap-[10px] mt-[5px]">
                                    <div className="flex items-center gap-[10px]">
                                        <img src={testtube} className='w-[20px]' alt="" />
                                        <h1 className='font-[500] leading-[18px]'>{t("Sample Type")}</h1>
                                    </div>
                                    <div className="bg-orange-100 border-[2px] max-w-[300px] border-[#8080803b] px-[10px] py-[1px] rounded-[5px] flex flex-wrap items-center gap-[10px]">
                                        {packageData?.sample_type.map((item, index) => {
                                            return <h1 key={index} className='font-[500] leading-[18px] py-[3px]'>{item},</h1>
                                        })}
                                    </div>
                                </div>
                                <div className="flex items-center gap-[10px] mt-[5px]">
                                    <div className="flex items-center gap-[10px]">
                                        <img src={restaurant} className='w-[20px]' alt="" />
                                        <h1 className='font-[500]'>{t("Fasting Required")}</h1>
                                    </div>
                                    <h1 className='bg-orange-100 border-[2px] border-[#8080803b] px-[10px] py-[1px] font-[500] rounded-[5px]'>{packageData?.fasting_require}</h1>
                                </div>
                                <div className="flex items-center gap-[10px] mt-[5px]">
                                    <div className="flex items-center gap-[10px]">
                                        <img src={clock_circle} className='w-[20px]' alt="" />
                                        <h1 className='font-[500]'>{t("Test Report Time")}</h1>
                                    </div>
                                    <h1 className='bg-orange-100 border-[2px] border-[#8080803b] px-[10px] py-[1px] font-[500] rounded-[5px]'>{packageData?.test_report_time}</h1>
                                </div>
                            </div>
                            <div className="mt-[20px]">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-[10px]">
                                        <img src={package_box} className='w-[20px]' alt="" />
                                        <h1 className='font-[500] text-[17px]'>{t("Package Includes")}</h1>
                                    </div>
                                    <h1 className='font-[500] text-[18px]'>{currency} {packageData?.package_price.reduce((acc, curr) => acc + curr, 0)}</h1>
                                </div>
                                <div className="px-[18px]">
                                    {packageData?.package_name.map((item, index) => {
                                        return <div key={index} className="flex items-center justify-between">
                                            <li>{item}</li>
                                            <span>$ {packageData?.package_price[index]}</span>
                                        </div>
                                    })}
                                </div>
                            </div>
                            <div className="mt-[10px]">
                                <div className="flex items-center gap-[10px]">
                                    <img src={invoice} className='w-[20px]' alt="" />
                                    <h1 className='font-[500] text-[17px]'>{t("Package Description")}</h1>
                                </div>
                                <p className='px-[10px]'>{packageData?.description}</p>
                            </div>
                        </div>}
                </div>
            </div>}

            {cartAddIndex >= 1 && <div className="w-[100%] flex justify-center fixed items-end left-0 right-0 bottom-[10px] z-[888]">
                <div className="w-[20%] max-_430_:w-[80%] max-_580_:w-[60%] max-_770_:w-[50%] max-_995_:w-[35%] max-_1205_:w-[30%] max-_1405_:w-[25%] bg-white border-[2px] border-[#8080803b] rounded-[10px] py-[10px] px-[15px]">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-[10px]">
                            <img src={CartIocn} alt="" />
                            <h1 className='font-[500] text-[18px]'>{cartAddIndex} {t("Item in Cart")}</h1>
                        </div>
                        <button onClick={() => navigate("/cart-booking")} className='py-[5px] px-[30px] bg-[#0d9488] text-white rounded-[10px] font-[500]'>{t("Proceed")}</button>
                    </div>
                </div>
            </div>}
        </div>
    )
}

export default PackagesDetails
/* jshint ignore:start */